import { ProDescriptions } from '@ant-design/pro-components';
import PropTypes from 'prop-types';

const seedTypeValueEnum = {
  hotPot: { text: '热点采集' },
  seedPlan: { text: '创作规划' },
};

const recommendedArcTypeValueEnum = {
  articleArc: { text: '文章' },
  scriptArc: { text: '脚本' },
};

const TopicLensPreview = ({ record }) => (
  <ProDescriptions
    column={1}
    dataSource={record || {}}
    columns={[
      {
        title: '种子标题',
        dataIndex: 'seedTitle',
        renderText: (_, item) => item.seedTitle || item.seedId,
      },
      { title: '种子类型', dataIndex: 'seedType', valueEnum: seedTypeValueEnum },
      { title: '选题标题', dataIndex: 'title' },
      { title: '目标受众', dataIndex: 'audience' },
      { title: '核心问题', dataIndex: 'coreQuestion' },
      { title: '内容张力', dataIndex: 'tension' },
      { title: '核心判断', dataIndex: 'thesis' },
      { title: '核心价值', dataIndex: 'value' },
      { title: '选题切角', dataIndex: 'angle' },
      { title: '关键要点', dataIndex: 'keyPoints' },
      { title: '方法路径', dataIndex: 'methodPath' },
      { title: '组织路径', dataIndex: 'habitPath' },
      { title: '收束意图', dataIndex: 'closingIntent' },
      {
        title: '推荐形态',
        dataIndex: 'recommendedArcType',
        valueEnum: recommendedArcTypeValueEnum,
      },
      { title: '推荐原因', dataIndex: 'recommendedArcReason' },
      { title: '状态', dataIndex: 'status' },
      { title: '结果原因', dataIndex: 'reason' },
      { title: '策划评分', dataIndex: 'score' },
      { title: '创作者', dataIndex: 'userName' },
      { title: '创建时间', dataIndex: 'createdAt', valueType: 'dateTime' },
    ]}
  />
);

TopicLensPreview.propTypes = {
  record: PropTypes.shape({}),
};

TopicLensPreview.defaultProps = {
  record: undefined,
};

export default TopicLensPreview;
